import { h, Host } from "@stencil/core";
export class StepItem {
    constructor() {
        this.current = false;
        this.done = false;
        this.number = 0;
    }
    render() {
        return (h(Host, { key: '4c9a33afa70ab53198d72e3a6132839378556db8', done: this.done, active: this.current, "aria-current": this.current ? "true" : undefined }, this.done ? h("ux-icon", { "aria-hidden": "true", name: "checkmark", weight: "bold" }) : this.number, h("p", { key: '6203da595ac6457daed5297e74ffdb6bc3786cd6' }, h("slot", { key: '5e371e2734678180448382b78d03791257a047c3' }))));
    }
    static get is() { return "ux-steps-item"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["steps-item.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["steps-item.css"]
        };
    }
    static get properties() {
        return {
            "current": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "indictates if step is active"
                },
                "attribute": "current",
                "reflect": false,
                "defaultValue": "false"
            },
            "done": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "indicates if step is done"
                },
                "attribute": "done",
                "reflect": false,
                "defaultValue": "false"
            },
            "number": {
                "type": "number",
                "mutable": false,
                "complexType": {
                    "original": "number",
                    "resolved": "number",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "number to be shown in the circle"
                },
                "attribute": "number",
                "reflect": false,
                "defaultValue": "0"
            }
        };
    }
}
//# sourceMappingURL=steps-item.js.map
